import { createDiffDecorationsPlugin } from '@heidi/editor/core';
import { Extension } from '@tiptap/react';

/**
 * markdown-native twin of the diff-decorations holder — thin wrapper around
 * the shared plugin in `tiptap/shared/diff-decorations`, never importing the
 * vMarkdown twin.
 */
export const DiffDecorationsExtension = Extension.create({
  name: 'diffDecorations',

  addProseMirrorPlugins() {
    return [createDiffDecorationsPlugin()];
  },
});
